/**
 * 이미지 경로를 CDN URL로 변환하는 유틸리티 함수
 */

/**
 * 이미지 경로를 CDN URL로 변환
 * - 이미 절대 URL인 경우 (http:// 또는 https://로 시작) 그대로 반환
 * - 상대 경로인 경우 (/images/...) CDN URL을 앞에 붙여서 반환
 * 
 * @param imagePath 이미지 경로
 * @returns CDN URL이 적용된 이미지 경로
 */
export function getImageUrl(imagePath: string | undefined | null): string {
    if (!imagePath) {
        return ''
    }

    // 이미 절대 URL인 경우 그대로 반환
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
        return imagePath
    }

    // CDN URL 환경 변수 확인 (VITE_CDN_URL 우선, 없으면 VITE_TIGRIS_BUCKET_URL 사용)
    // 프로덕션 환경에서는 기본값으로 Tigris CDN URL 사용
    const env = import.meta.env as any
    const cdnUrl = env.VITE_CDN_URL || 
                   env.VITE_TIGRIS_BUCKET_URL || 
                   (env.PROD ? 'https://blackpork1931.t3.storage.dev' : '')
    
    // CDN URL이 설정되지 않은 경우 원본 경로 반환
    if (!cdnUrl) {
        return imagePath
    }

    // CDN URL이 이미 포함되어 있는지 확인
    if (imagePath.startsWith(cdnUrl)) {
        return imagePath
    }

    // 상대 경로를 CDN URL과 결합
    // /images/... 형태의 경로를 ${CDN_URL}/images/...로 변환
    const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath
    const cleanCdnUrl = cdnUrl.endsWith('/') ? cdnUrl.slice(0, -1) : cdnUrl
    
    return `${cleanCdnUrl}/${cleanPath}`
}

/**
 * 여러 이미지 경로를 한 번에 CDN URL로 변환
 * 
 * @param imagePaths 이미지 경로 배열
 * @returns CDN URL이 적용된 이미지 경로 배열
 */
export function getImageUrls(imagePaths: (string | undefined | null)[]): string[] {
    return imagePaths.map(path => getImageUrl(path))
}

